import { RouteConfig } from "vue-router";

export const REmployeeHome: RouteConfig = {
  path: "home",
  name: "EmployeeHome",
  component: () =>
    import(
      /* webpackChunkName: "employee-home" */
      "./VEmployeeHome.vue"
    ),
  meta: {
    title: "Home",
    icon: "grid-outline",
    newIcon: "home",
  },
};
